import { ascend, filter, find, path, propEq, sortWith, values } from 'ramda';
import { getRawPromoList } from 'reactApp/modules/billingData/billingData.helpers';
import { getBillingDataRoot } from 'reactApp/modules/billingData/billingData.selectors';
import { createSelector } from 'reselect';

const isDiscount = (item) => item.type === 'discount';
const isQuota = (item) => item.type === 'quota';
const isRustore = (item) => item.type === 'rustore';

const getBillindDataPromoRaw = createSelector(getBillingDataRoot, ({ rawBillingData }) => getRawPromoList(rawBillingData));

const getPromoTariffs = createSelector(getBillingDataRoot, (state) => state.promoTariffs);

const getPromoById = createSelector(
    (state, _) => getPromoTariffs(state),
    (_, id) => id,
    (list, id) => list[id]
);

// discount
const getDiscountPromo = createSelector(getPromoTariffs, filter(isDiscount));

const sortDiscountPromoBySpace = createSelector(getDiscountPromo, (list) =>
    sortWith([ascend(path(['unlocked', 'space', 'original'])), ascend(path(['id']))], values(list))
);

const getDiscountByProductId = createSelector(
    getDiscountPromo,
    (_, productId) => productId,
    (list, productId) => find(propEq('productId', productId), values(list))
);

const getPromoListToShow = createSelector(
    getPromoTariffs,
    filter((item) => isQuota(item) || isRustore(item))
);

const sortPromoListToShow = createSelector(getPromoListToShow, (list) =>
    sortWith([ascend(path(['space', 'original'])), ascend(path(['id']))], values(list))
);

export const BillingDataPromoSelectors = {
    getBillindDataPromoRaw,
    getPromoTariffs,
    getPromoById,
    getDiscountPromo,
    sortDiscountPromoBySpace,
    getDiscountByProductId,
    getPromoListToShow,
    sortPromoListToShow,
};
